import React from 'react';
import PropTypes from 'prop-types';
import LoadingShimmer from '~/shared/components/LoadingShimmer';
import {Typography} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const DeliveryMessage = props => {
  return (
    <div className="ndx-DeliveryMessage">
      <Typography
        component="div"
        variant="uiTextDefault"
        className="ndx-DeliveryMessage-primaryText">
        {props.loading ? (
          <LoadingShimmer styles={{height: '11px'}} />
        ) : (
          props.primaryText
        )}
      </Typography>

      {props.loading ? (
        <LoadingShimmer
          styles={{height: '9px', width: '80%', marginTop: '4px'}}
        />
      ) : (
        props.secondaryText && (
          <Typography
            component="div"
            variant="uiTextSmall"
            className="ndx-DeliveryMessage-secondaryText">
            {props.secondaryText}
          </Typography>
        )
      )}
    </div>
  );
};

const propTypes = {
  loading: PropTypes.bool,
  primaryText: PropTypes.node,
  secondaryText: PropTypes.node
};

DeliveryMessage.propTypes = propTypes;

export default DeliveryMessage;
